module.exports = __webpack_public_path__ + "img/plan.df41470e.png";